
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"47","height":"34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M45.67 2.404c0-.835-.684-1.519-1.519-1.519h-41c-.835 0-1.518.683-1.518 1.519v28.852c0 .835.683 1.518 1.518 1.518h41c.835 0 1.519-.683 1.519-1.518V2.404z","fill":"#fff"}}),_c('path',{attrs:{"d":"M3.91 3.163v26.574H1.634v1.518c0 .84.68 1.519 1.518 1.519h41c.835 0 1.519-.683 1.519-1.518V3.163H3.91z","fill":"#ECEFF1"}}),_c('path',{attrs:{"d":"M44.151 33.533h-3.037a.76.76 0 010-1.518h3.037a.76.76 0 00.76-.76V2.405a.76.76 0 00-.76-.76h-41a.76.76 0 00-.759.76v28.852c0 .417.34.759.76.759h38.583a.76.76 0 010 1.518H3.151a2.28 2.28 0 01-2.277-2.277V2.404A2.28 2.28 0 013.15.126h41a2.28 2.28 0 012.278 2.278v28.852a2.28 2.28 0 01-2.278 2.277z","fill":"#455A64"}}),_c('path',{attrs:{"d":"M19.855 30.496H1.633a.76.76 0 010-1.518h18.222a.76.76 0 010 1.518zM22.891 30.496a.754.754 0 01-.76-.759c0-.197.077-.395.213-.533a.783.783 0 011.079-.015c.151.153.227.35.227.548a.713.713 0 01-.227.532.713.713 0 01-.532.227z","fill":"#455A64"}}),_c('circle',{attrs:{"cx":"8.385","cy":"8.385","r":"8.385","transform":"matrix(1 0 0 -1 16.338 25.924)","fill":"#CFD8DC"}}),_c('path',{attrs:{"d":"M27.358 15.964a1 1 0 010 1.732L22.88 20.28a1 1 0 01-1.5-.866v-5.169a1 1 0 011.5-.866l4.477 2.585z","fill":"#455A64"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M33.924 16.83c0-5.473-4.437-9.91-9.91-9.91s-9.91 4.437-9.91 9.91c0 5.472 4.437 9.91 9.91 9.91s9.91-4.438 9.91-9.91zm-9.91-8.61a8.61 8.61 0 110 17.22 8.61 8.61 0 010-17.22z","fill":"#455A64"}})])
          )
        }
      }
    